<template>
  <h3>Обзор результата – Перестрахование</h3>
  <div class="block">
    <p>В данном разделе предоставлен свод по всем сущностям и проведённым расчетам по прямому бизнесу. Чтобы посмотреть нужный тип бизнеса, пользователь должен выбрать опции из фильтра:</p>
    <img src="@/assets/img/guide/result-reinsurance-select.png" alt="" srcset="">
    <p>В данном разделе «Перестрахование» отображены все методы, созданные в разделе «Перестрахование» по всем сущностям. Исходным методом указан метод «ЦЛ» в таблице «Доля перестраховщиков в резерве убытков»; для других сущностей исходным методом является метод «Доля от резерва».</p>
    <img src="@/assets/img/guide/result-reinsurance-share.png" alt="" srcset="">
    <img src="@/assets/img/guide/result-reinsurance-pryam.png" alt="" srcset="">
    <p>Также, в каждом периоде можно выбрать другой метод расчета, нажав на столбец «РУ» в другом варианте расчета или ввести значения в таблице «Доля перестраховщиков в Резерве убытков» вручную используя столбец «Ручной ввод».</p>
    <img src="@/assets/img/guide/result-reinsurance-share-selected.png" alt="" srcset="">
    <p>Когда расчет по сущности готов, пользователь может отправить его на проверку или утвердить, нажав на кнопки «Отправить на проверку» и «Утвердить» в шапке расчета. Данный функционал зависит от Вашей должности согласно Ролевой модели.</p>
    <img src="@/assets/img/guide/result-reinsurance-header.png" alt="" srcset="">
  </div>
</template>
  
<script>
export default {
  name: 'ResultReinsurance',
}
</script>

<style scoped>
h3{
  font-size: 32px;
  color: #0074b5;
}

h5{
  margin: 20px 0px;
  font-size: 24px;
  color: #0074b5;
}

.list{
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.list p{
  font-size: 16px;
}

table, th, td {
  color: #6b6f77;
  border: 1px solid black;
  border-collapse: collapse;

  margin: 20px 0px;
}

th{
  padding: 0px 10px;
}

td:nth-child(1){
  padding: 10px;
}

td:nth-child(2){
  padding: 10px 10px 10px 30px;
}

ul{
  display: flex;
  flex-direction: column;
  gap: 10px;

  margin: 20px 20px 20px 50px;
}

td ul{
  margin-left: unset;
}

ol{
  margin-left: 50px;
}

ol li{
  margin-top: 10px;
}

li p{
  margin-top: 10px;
}

ol li ul{
  margin-left: 50px;
}

p{
  margin-top: 10px;
  line-height: 20px;
}

img{
  max-width: 100%;
  margin: 50px 0px;
}
</style>
